<script>
  import { createEventDispatcher } from 'svelte';

  import firebase from "firebase/app";

  const dispatch = createEventDispatcher();

  export let issueId;

  let answerer = "";
  let body = "";

  $: voteEnabled = (answerer !== "" && body !== "");

  async function submit() {
    await createAnswer();
    answerer = "";
    body = "";
  }

  async function createAnswer() {
    const db = firebase.database();

    await db.ref(`/answers/${issueId}`).push({
      answerer,
      body,
      point: 0,
      createdAt: (new Date()).toISOString(),
    });
    dispatch("save", {});
  }
</script>
<form>
  <label for="answerer">ニックネーム</label><br />
  <input name="answerer" type="text" bind:value={answerer} /><br />
  <label for="body">内容</label><br />
  <textarea name="body" bind:value={body}></textarea><br />
  <button disabled={!voteEnabled} type="button" on:click={submit}>投稿</button>
</form>
<style>
  textarea {
    width: 300px;
    height: 64px;
  }
</style>
